import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
export const UserPageContentWrapper = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: "w-full relative -top-[110px] md:-top-[150px] mb-4 px-4 md:px-7 lg:px-8 lg:mb-10",
        children: children
    });
};
